import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { CrearVlanParametros } from '../shared/models/crear-vlan-parametros';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-crear-vlan',
  templateUrl: './crear-vlan.component.html',
  styleUrls: ['./crear-vlan.component.css']
})
export class CrearVlanComponent implements OnInit {

  principalForm = this.formBuilder.group({
    selectCompania: new FormControl('', Validators.required),
    selectCiudad: new FormControl(),
    selectSede: new FormControl(),
    selectMascara: new FormControl(),
    selectAmbiente: new FormControl(),
    imputVlan: ['', Validators.required],
    textAreaObeservaciones: new FormControl(),
  });

  private codigoListaMascaras = environment.listaCodigoMascara;
  private codigoMascaraCloud = environment.listaItemMascaraCloud;
  mensajeVlanNoCreada = 'No se ha podido crear una VLAN con los parametros seleccionado';
  
  permiso: boolean;
  companias: Compania[];
  companiaSeleccionada: Compania = new Compania();
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  idCompaniaSeleccionada: number;
  idCiudadSeleccionada: number;
  idSedeSeleccionada: number;
  idAmbienteSelecccionado: number;
  idVlanSeleccionado: number;
  ambientes: ListaItem[];
  mascaras: ListaItem[];
  mascarasFiltradas: ListaItem[];
  idMascaraSeleccionada: number;
  nombreVlan: string;
  observaciones: string;
  parametros: CrearVlanParametros = new CrearVlanParametros();
  modalRef: NgbModalRef;
  mensajeAlerta: string;
  cloudSeleccionada = false;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService) { }

  ngOnInit() {
    this.sesionService.permisoCrearVlan().subscribe(
      resultado => this.permiso = resultado
    );
    this.listarCompanias();
    this.listarMascaras();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado.filter(Compania => Compania.idCompania!=8)
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarCiudadaesPorCompania(): void {
    this.seleccionarCompania();
    this.idCiudadSeleccionada = null;
    this.idSedeSeleccionada = null;
    this.idAmbienteSelecccionado = null;
    this.idVlanSeleccionado = null;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.idMascaraSeleccionada = null;
    this.ciudadService.ciudadesPorIdCompania(this.companiaSeleccionada.idCompania).subscribe(
      resultado => this.ciudades = resultado.filter(Ciudad => Ciudad.idCiudad!=3)
    );
    
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeSeleccionada = null;
    this.idAmbienteSelecccionado = null;
    this.idVlanSeleccionado = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.idMascaraSeleccionada = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
    this.seleccionaCloud();
    if (this.cloudSeleccionada) {
      this.seleccionarMascaraCloud();
      this.principalForm.controls['selectMascara'].disable();
    } else {
      this.principalForm.controls['selectMascara'].enable();
    }
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = null;
    this.idVlanSeleccionado = null;
    this.ambientes = null;
    this.vlans = null;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe(
      resultado => this.ambientes = resultado
    );
  }

  public listarMascaras(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaMascaras).subscribe(
      resultado => this.mascaras = resultado
    );
  }

  public guardarVlan(cargandoModal, alertaModal, resultadoModal): void {
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    this.settearParametros();
    this.administradorIpService.crearVlan(this.parametros).subscribe(
      resultado => {
        this.parametros = resultado;
        this.modalRef.close();
        if (this.parametros.vlanCreada == null ||
          this.parametros.vlanCreada.idVlan == null ) {
          this.mensajeAlerta = this.mensajeVlanNoCreada;
          this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
        } else {
          this.modalRef = this.modalService.open(resultadoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
        }
      }
    );
  }

  public settearParametros(): void {
    this.parametros.idAmbiente = this.idAmbienteSelecccionado;
    this.parametros.idCiudad = this.idCiudadSeleccionada;
    this.parametros.compania = this.companiaSeleccionada;
    this.parametros.idMascara = this.idMascaraSeleccionada;
    this.parametros.idSede = this.idSedeSeleccionada;
    this.parametros.nombreVlan = this.nombreVlan;
    this.parametros.observaciones = this.observaciones == null ? '' : this.observaciones;
  }

  public ocultarModalResultado(): void {
    this.parametros = new CrearVlanParametros();
    this.principalForm.reset();
    this.modalRef.close();
  }

  public seleccionarMascaraCloud(): void {
    const mascaraSeleccionada = this.mascaras.find(
      mascara => mascara.codigoItem == this.codigoMascaraCloud
    );
    this.idMascaraSeleccionada = mascaraSeleccionada.idListaItem;
  }

  public seleccionaCloud() {
    if (this.idCiudadSeleccionada != null) {
      const ciudadSeleccionada = this.ciudades.find(
        ciudad => ciudad.idCiudad == this.idCiudadSeleccionada
      );
      if (ciudadSeleccionada != null
        && ciudadSeleccionada.nombreCiudad.toUpperCase() == 'CLOUD') {
        this.cloudSeleccionada = true;
      } else {
        this.cloudSeleccionada = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/crear-vlan/crear-vlan.component.ts